export default "__VITE_ASSET__CyQS4Q0k__"